const innerNavigationLinkHelper = (link: string): string => {
    const [, route] = link.split('://')
    return route
}

export default innerNavigationLinkHelper
